/**
 * HTML entity encoding for user-controlled values interpolated into i18n
 * messages that are rendered with v-html (fix for VULN-02 — Stored XSS).
 */
const HTML_ENTITIES = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

export function escapeHtml(value) {
  return value == null
    ? ""
    : String(value).replace(/[&<>"']/g, (c) => HTML_ENTITIES[c]);
}

export function escapeHtmlParams(params) {
  if (!params || typeof params !== "object") return params;
  const escaped = Array.isArray(params) ? [] : {};
  for (const [key, value] of Object.entries(params)) {
    escaped[key] = typeof value === "string" ? escapeHtml(value) : value;
  }
  return escaped;
}
